import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentLinkService } from '../../services/payment-link.service';
import { LoadingService } from '../../services/loading.service';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-payment-links',
    templateUrl: './payment-links.component.html',
    styleUrls: ['./payment-links.component.scss']
})
export class PaymentLinksComponent implements OnInit {
    paymentLinks: any[] = [];

    // Paginación
    totalCount = 0;
    pageNumber = 1;
    pageSize = 20;
    totalPages = 0;

    // Filtros
    searchTerm = '';
    isActiveFilter: boolean | null = null;
    dateFrom: string = '';
    dateTo: string = '';
    sortBy = 'GeneratedDate';
    sortDescending = true;

    constructor(
        private paymentLinkService: PaymentLinkService,
        private loadingService: LoadingService,
        private toastService: ToastService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.loadingService.show();

        const params: any = {
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
            sortBy: this.sortBy,
            sortDescending: this.sortDescending
        };

        if (this.isActiveFilter !== null) {
            params.isActive = this.isActiveFilter;
        }
        if (this.dateFrom) {
            params.dateFrom = this.dateFrom;
        }
        if (this.dateTo) {
            params.dateTo = this.dateTo;
        }
        if (this.searchTerm.trim()) {
            params.searchTerm = this.searchTerm.trim();
        }

        this.paymentLinkService.getPaymentLinks(params).subscribe({
            next: (response) => {
                this.loadingService.hide();
                if (response.isSuccess) {
                    this.paymentLinks = response.data.items;
                    this.totalCount = response.data.totalCount;
                    this.totalPages = response.data.totalPages;
                } else {
                    this.toastService.showToast('error', 'Error al cargar los links de pago');
                }
            },
            error: (error) => {
                this.loadingService.hide();
                console.error('Error al cargar payment links:', error);
                this.toastService.showToast('error', 'Error al cargar los links de pago');
            }
        });
    }

    onPageChange(event: any): void {
        this.pageNumber = event.page + 1;
        this.pageSize = event.rows;
        this.loadData();
    }

    onFilterChange(): void {
        this.pageNumber = 1;
        this.loadData();
    }

    toggleSortOrder(): void {
        this.sortDescending = !this.sortDescending;
        this.loadData();
    }

    clearFilters(): void {
        this.searchTerm = '';
        this.isActiveFilter = null;
        this.dateFrom = '';
        this.dateTo = '';
        this.pageNumber = 1;
        this.loadData();
    }

    viewDetail(id: number): void {
        this.router.navigate(['/dashboard/payment-links', id]);
    }

    formatCurrency(amount: number, currencyCode: string = 'COP'): string {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: currencyCode === 'COP' ? 0 : 2,
            maximumFractionDigits: currencyCode === 'COP' ? 0 : 2
        }).format(amount);
    }

    formatDate(date: string): string {
        if (!date) return '-';
        return new Date(date).toLocaleDateString('es-CO', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }

    getStatusClass(link: any): string {
        if (!link.isActive) return 'bg-gray-100 text-gray-600';
        if (link.isExpired) return 'bg-red-100 text-red-600';
        return 'bg-green-100 text-green-600';
    }

    getStatusText(link: any): string {
        if (!link.isActive) return 'Inactivo';
        if (link.isExpired) return 'Expirado';
        return 'Activo';
    }

    async copyToClipboard(url: string): Promise<void> {
        try {
            await this.paymentLinkService.copyToClipboard(url);
            this.toastService.showToast('success', '✅ Link copiado al portapapeles');
        } catch (error) {
            this.toastService.showToast('error', 'Error al copiar el link');
        }
    }
}
